import {Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDrawer} from '@angular/material';
import {InjectionRootComponent} from '../injection-root/injection-root.component';
import {RequestBodyVacations, ResponseBodyVacations, VacationVO} from '../InjectionVO';
import {TimeZoneService} from '../../../service/TimeZoneService';
import * as moment from 'moment';
import {ApiService} from '../api.service';
import {BaseComponent} from '../BaseComponent';
import {VacationAndBreak} from '../../vacationAndBreak';
import {Vacation} from '../../../model/vacation';
import {DATE_DEFAULT_FORMAT, DATE_TIME_FORMAT} from '../../../model/commons/DateConstants';
import {BlockService} from '../../../service/BlockService';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'injection-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent extends BaseComponent implements OnInit {
  @ViewChild('tmpl') public tmpl: any;
  public vacations: Array<VacationVO> = [];
  public data: any;
  public styleAvatar = {'background-color': '#f7f7f7'};
  public motifs: Promise<Array<any>>;
  public _showDialog: boolean = false;
  addTheSecondVacation: boolean = true;
  public _expanded: number = 0;
  public _break: string = 'NONE';
  public _motif: string = '';
  public _motifArea: string = null;
  public timeZone: number = 0;
  public _labelTimeZone: string = 'Fuseau horaire:';
  hoursBreakFiletred: Array<any> = this.hoursBreak;
  hoursBreakChecked: Array<any> = this.hoursBreak;

  reasons: Array<{ index: number, field: string, reason: string }> = [];
  _send: boolean = false;
  isEditInjection: boolean = false;
  injectionData: RequestBodyVacations = new RequestBodyVacations();
  dataRealiseAllInjection = [];
  visibleDrawerValidationInjection: boolean = false;
  isDS: boolean = false;
  @ViewChild('drawerValidation') drawer: MatDrawer;

  constructor(public dialogRef: MatDialogRef<InjectionRootComponent>, public tz: TimeZoneService, public blockservice: BlockService,
              @Inject(MAT_DIALOG_DATA) public injectData: any, private serviceApi: ApiService) {
    super();
  }

  ngOnInit() {
    this.data = this.injectData;
    this.styleAvatar['background-image'] = `url(${environment.api.mscore+'picture/default/' + this.injectData.user.username})`;
    this.timeZone = this.tz.payload.timeZone;
    this.motifs = this.serviceApi.getMotifs('DEMANDE');
    console.log('data : ', this.data);
    const matricule = this.data.user.username;
    console.log(' data :', this.data);
    const date = moment(this.data.user.date).format('YYYY-MM-DD');
    this.getCurrentVacations(matricule, date);
    this.loadAllBlockRealizedByUsernameDate(matricule, date);
  }

  validatorVacations(): { isvalid: boolean; reasons: Array<{ index: number, field: string, reason: string }> } {
    this.reasons = [];
    let isvalid = this.vacations.filter((e, index) => {
      if (index == 0 && !e.start1) {
        this.reasons.push({index, field: 'all', reason: 'ALL_VACATION_IS_EMPTY'});
      }
      if (!this.reasons.length) {
        /*    if(!e.start1) {
              this.reasons.push({index, field: 'start1', reason: 'FIELD_IS_EMPTY'})
            }*/

        if (e.start1 && !e.end1) {
          this.reasons.push({index, field: 'end1', reason: 'FIELD_IS_EMPTY'});
        }
        /*if(e.start1 && e.end1 && !e.start2) {
          reasons.push({index, field: 'start2', reason: 'IS_EMPTY'})
        }*/

        if (e.start1 && e.end1 && e.start2 && !e.end2) {
          this.reasons.push({index, field: 'end2', reason: 'FIELD_IS_EMPTY'});
        }
      }

      return (e.start1 && e.end1 && !e.start2) || (e.start1 && e.end1 && e.start2 && e.end2);
    }).length == 0;

    const periodBreaks = this.vacations.map((v) => this.InVacationsPeriod(v));
    if (periodBreaks.filter(e => e !== null).length) {
      periodBreaks.forEach((k, i) => {
        this.reasons.push({index: i, field: 'BREAK', reason: k});
      });
      isvalid = true;
    }

    return {isvalid: isvalid, reasons: this.reasons};
  }

  get totalVacations() {
    const count = this.vacations.map((v: VacationVO) => this.diffHhMm(v.start1, v.end1) + this.diffHhMm(v.start2, v.end2));

    return count.reduce((p: number, c: number) => p + c, 0);
  }

  getTotalVacation(index) {
    const item = [this.vacations[index]];
    const count = item.map((v: VacationVO) => this.diffHhMm(v.start1, v.end1) + this.diffHhMm(v.start2, v.end2));
    return count.reduce((p: number, c: number) => p + c, 0);
  }

  get timeZoneLabel() {
    const {payload} = this.tz;
    const {city} = payload;
    let padZero = (v: number) => {
      v = v < 0 ? v * -1 : v;
      return (v < 10 ? '0' + v : (v)) + ':00';
    };
    let tz: any = this.timeZone;
    return {city, hour: (tz > -1 ? '' : '-') + padZero(this.timeZone)};
  }

  addVacation() {
    if (this.vacations.length == 1 && this.vacations.length <= 2) {
      this.addTheSecondVacation = false;
      this.vacations.push({
        endPausse: '',
        startPausse: '',
        start1: null,
        start2: null,
        end1: null,
        end2: null
      });
      this._expanded = this.vacations.length - 1;
    }
  }

  rmVacation(index) {
    this.vacations = this.vacations.filter((e, i) => i != index);
    //this.addVacation();
    this.addTheSecondVacation = true;
  }

  /* controles */
  hasValidatedVacation(vacation: VacationVO) {
    return vacation.start1 < vacation.end1 && vacation.end1 < vacation.start1 && vacation.start2 < vacation.end2;
  }

  diffHhMm(m1, m2) {
    const d1 = new Date('2023-01-01 ' + m1);
    const d2 = new Date('2023-01-01 ' + m2);
    const m = m1 && m2 && (d2.getMinutes() > 30 || d1.getMinutes() > 30) ? 1 : 0;
    return m1 && m2 ? (d2.getHours() - d1.getHours()) + m : 0;
  }


  checkValidaty(index, hour: string, key: string) {
    this.hoursBreakChecked = this.hoursBreak.filter(h => !this.checkRowsValues(this.vacations, index, h, key));
    this.hoursBreakFiletred = this.hoursBreakChecked;
    //return this.checkRowsValues(this.vacations, index, hour, key);
  }

  save() {
    const {isvalid} = this.validatorVacations();
    this.visibleDrawerValidationInjection = false;
    this._showDialog = isvalid;
    if (this.totalVacations > 10) {
      this.reasons.push({
        index: -1,
        reason: 'LIMIT_MAX_HOURS_MSSG',
        field: 'TOTAL_VACATION'
      });
      this._showDialog = true;
    }

    if (!this._motif.length) {
      this.reasons.push({
        index: -1,
        reason: 'MOTIF_IS_REQUIRED',
        field: 'MOTIF'
      });
      this._showDialog = true;
    }
    if (this._motif == 'OTHER' && (!this._motifArea || this._motifArea && !this._motifArea.length)) {
      this.reasons.push({
        index: -1,
        reason: 'COMMENT_MOTIF_IS_REQUIRED',
        field: 'COMMENT_MOTIF'
      });
      this._showDialog = true;
    }


    if (!this._showDialog) {
      this.isRealise = this.checkIfAnyRealiseBlockAlreadyExist();
      this.isTotallyOverlapped = this.isTotallyOverlappedWithRealized();
      if (this.isRealise || this.isTotallyOverlapped) {
        this.drawer.open();
        this.visibleDrawerValidationInjection = true;
      } else {
        this.saveData();
        this.visibleDrawerValidationInjection = false;
      }
    }
  }
  isRealise: boolean = false
  isTotallyOverlapped : boolean = false;
  saveData() {
    const {user} = this.data;
    const date = moment(user.date).format('YYYY-MM-DD');
    const formatVacation = (d, h) => moment(`${d} ${h}`).format('YYYY-MM-DD HH:mm');
    const payload: RequestBodyVacations = {
      'matricule': user.username,
      'fullName': [user.firstName, user.lastName].join(' '),
      'forceSiFormation': false,
      'vacationAndPausesVo': new VacationAndBreak(),
      'timezone': this.timeZone,
      'injectionAction': this.isEditInjection ? 'edit' : 'add',
      'date': date,
      'pause': parseInt(this._break),
      "etat": this.getStateInjection(),
      'motif': this._motif == 'OTHER' ? this._motifArea : this._motif,
      'other': this._motif == 'OTHER'
    };
    // payload.vacationAndPausesVo = new Array(this.vacations.length);
    let vacationAndBreak: VacationAndBreak = new VacationAndBreak();
    this.vacations.forEach((v: VacationVO, index) => {
      if (v.start1 && v.end1) {
        let vacation: Vacation = new Vacation();
        vacation.debut = formatVacation(date, v.start1);
        vacation.fin = formatVacation(date, v.end1);
        vacationAndBreak.vacations.push(vacation);
      }
      if (v.start2 && v.end2) {
        let vacation: Vacation = new Vacation();
        vacation.debut = formatVacation(date, v.start2);
        vacation.fin = formatVacation(date, v.end2);
        vacationAndBreak.vacations.push(vacation);
      }

      if (v.startPausse && v.endPausse) {
        if (v.startPausse >= v.endPausse) {
          this.reasons.push({
            index: -1,
            reason: 'ERROR_IN_PAUSE_ENTRY',
            field: ''
          });
          this._showDialog = true;
        }
        let pausse: Vacation = new Vacation();
        pausse.debut = formatVacation(date, v.startPausse);
        pausse.fin = formatVacation(date, v.endPausse);
        vacationAndBreak.pauses.push(pausse);
      }
    });
    payload.vacationAndPausesVo = vacationAndBreak;
    this._send = true;
    this.serviceApi.saveVacations([payload])
      .then((resp: ResponseBodyVacations) => {
        this._send = false;
        if (resp.success) {
          this.getCurrentVacations(payload.matricule, moment(this.data.user.date).format('YYYY-MM-DD'));
         if (this.isDS)
           this.drawer.open();
         else
           this.dialogRef.close(true);
        } else {
          this.reasons.push({
            index: -1,
            field: 'FEED_BACK_BACKEND',
            reason: resp.notValidItems[0].failedReasons[0]
          });
        }
      })
      .catch((reason => {
        this._send = false;
        this.reasons.push({
          index: -1,
          field: 'SAVE',
          reason: JSON.stringify(reason)
        });
      })).then(() => {
      if (this.reasons.length) {
        this._showDialog = true;
      }
    });
    console.log('payload:', payload);
  }

  getStateInjection(){
    if (this.isTotallyOverlapped) return 2;
    if (this.isRealise) return 1;
    return 0;
  }
  private getCurrentVacations(matricule, date) {
    this.serviceApi.getCurrentVacationsV2(matricule, date).subscribe(response => {
      if (response) {
        this._motif = response.motif;
        if (response.vacationAndPausesVo.vacations) {
          this.isEditInjection = true;
          response.vacationAndPausesVo.vacations.forEach((vacationAndPause, index) => {
            let vacationVo: VacationVO = new VacationVO();
            if (index == 0) {
              vacationVo.start1 = moment(vacationAndPause.debut).format('HH:mm');
              vacationVo.end1 = moment(vacationAndPause.fin).format('HH:mm');
              this.vacations.push(vacationVo);
            } else if (index == 1) {
              this.vacations[0].start2 = moment(vacationAndPause.debut).format('HH:mm');
              this.vacations[0].end2 = moment(vacationAndPause.fin).format('HH:mm');
            } else if (index == 2) {
              vacationVo.start1 = moment(vacationAndPause.debut).format('HH:mm');
              vacationVo.end1 = moment(vacationAndPause.fin).format('HH:mm');
              this.vacations.push(vacationVo);
            } else if (index == 3) {
              this.vacations[1].start2 = moment(vacationAndPause.debut).format('HH:mm');
              this.vacations[1].end2 = moment(vacationAndPause.fin).format('HH:mm');
            }

          });

        }

        if (response.vacationAndPausesVo.pauses) {
          response.vacationAndPausesVo.pauses.forEach((vacationAndPause, index) => {
            if (index == 0) {
              this.vacations[0].startPausse = moment(vacationAndPause.debut).format('HH:mm');
              this.vacations[0].endPausse = moment(vacationAndPause.fin).format('HH:mm');
            } else if (index == 1) {
              this.vacations[1].startPausse = moment(vacationAndPause.debut).format('HH:mm');
              this.vacations[1].endPausse = moment(vacationAndPause.fin).format('HH:mm');
            }

          });
        }
      } else {
        this.initVacation();
      }

    });
  }

  setPausse(key: string, i: number, vacation: VacationVO) {
    if (key == 'startPausse' && vacation.startPausse) {
      vacation.endPausse = moment(vacation.startPausse, 'HH:mm').add('minutes', 15).format('HH:mm');
    }

  }

  private initVacation() {
    this.vacations = [];
    this.isEditInjection = false;
    let vaca: VacationVO = new VacationVO();
    vaca.start1 = null;
    vaca.end1 = null;
    vaca.start2 = null;
    vaca.end2 = null;
    vaca.startPausse = null;
    vaca.endPausse = null;
    this.vacations.push(vaca);
  }

  InVacationsPeriod(vacation: VacationVO, index?: number) {
    const sp = moment(vacation.startPausse, 'HH:mm');
    const ep = moment(vacation.endPausse, 'HH:mm');

    if (vacation.startPausse && !vacation.endPausse) {
      return 'BREAK_END_REQUIRED_VALUE';
    }

    if (!vacation.startPausse && vacation.endPausse) {
      return 'BREAK_START_REQUIRED_VALUE';
    }

    if (vacation.startPausse && vacation.endPausse) {
      if (ep.isSameOrBefore(sp)) {
        return 'BREAK_END_SUP_START';
      }

      const hasIn = this.vacations.filter((v: VacationVO) => {
        console.log('====>', v);
        let s1 = moment(v.start1, 'HH:mm');
        let e1 = moment(v.end1, 'HH:mm');

        let s2 = moment(v.start2, 'HH:mm');
        let e2 = moment(v.end2, 'HH:mm');

        const c1 = sp.isBetween(s1, e1, null, '[]');
        const c2 = ep.isBetween(s1, e1, null, '[]');

        let d1: any = c1 && c2;
        let d2: any = c1 && c2;
        if (v.start2 && v.end2) {
          d1 = sp.isBetween(s2, e2, null, '[]');
          d2 = ep.isBetween(s2, e2, null, '[]');
        }
        return (c1 && c2) ? (c1 && c2) : (d1 && d2);
      }).length > 0;
      if (!hasIn) {
        return 'BREAK_OUT_VACATIONS';
      }
    }
    return null;
  }

  checkSecondVacationExist(index: number) {
    return index == 0 || (index == 1 && !this.addTheSecondVacation);
  }

  doFilter(filter: string, key: string) {
    this.hoursBreakFiletred = this.hoursBreakChecked.filter((hour) =>
      hour.includes(filter)
    );
  }

  private loadAllBlockRealizedByUsernameDate(username, date) {
    let injectionUsernameDate = [{username: username, date: date}];
    this.dataRealiseAllInjection = [];
    this.blockservice.loadBlockRealizedByDateMatricule(injectionUsernameDate).subscribe((res: any) => {
      this.dataRealiseAllInjection = res;
    });
  }

  private checkIfAnyRealiseBlockAlreadyExist(): boolean {
    const username = this.data.user.username;
    const date = moment(this.data.user.date).format('YYYY-MM-DD');
    let isRealiseExist = false;
    isRealiseExist = this.checkIfRealiseExist(username, date);
    if (isRealiseExist) {
      return isRealiseExist;
    }

    return isRealiseExist;
  }

  private checkIfRealiseExist(username, date) {
    let list = this.dataRealiseAllInjection.filter(block =>
      block && block.user && block.user.username == username &&
      moment(date).isSameOrAfter(moment(block.start).format(DATE_DEFAULT_FORMAT)));
    return list.length > 0;
  }

  closeDrawer() {
    this.drawer.close();
    this.visibleDrawerValidationInjection = false;
    this.isTotallyOverlapped = false;
    this.isDS?this.dialogRef.close(true):this.dialogRef.close();
    this.isDS = false;
  }

  private isTotallyOverlappedWithRealized() {
    let blockRealiseEmpty: any[] = [];
    const username = this.data.user.username;
    const date = moment(this.data.user.date).format('YYYY-MM-DD');
    const allBlockRealiseOfBInjected = this.dataRealiseAllInjection.filter(block =>
      block && block.user && block.user.username == username &&
      moment(date).isSameOrAfter(moment(block.start).format(DATE_DEFAULT_FORMAT)));
    blockRealiseEmpty = [];
    allBlockRealiseOfBInjected.sort((b, a) => new Date(b.start).getTime() - new Date(a.start).getTime());
    allBlockRealiseOfBInjected.forEach((block, index) => {
      if (index == 0 || index == allBlockRealiseOfBInjected.length - 1) {
        let start = moment(block.start).utcOffset(0);
        let end = moment(block.start).utcOffset(0);
        if (index == 0) {
          start.set({hour: 0, minute: 0, second: 0, millisecond: 0});
          blockRealiseEmpty.push({
            start: moment(start).format(DATE_TIME_FORMAT),
            end: moment(block.start).format(DATE_TIME_FORMAT)
          });
        }
        if (index == allBlockRealiseOfBInjected.length - 1) {
          end.set({hour: 23, minute: 59, second: 0, millisecond: 0});
          blockRealiseEmpty.push({
            start: moment(allBlockRealiseOfBInjected[index].end).format(DATE_TIME_FORMAT),
            end: moment(end).format(DATE_TIME_FORMAT)
          });
        }
      }
      if (index > 0) {
        if (!moment(block.start).isSame(moment(allBlockRealiseOfBInjected[index - 1].end))) {
          blockRealiseEmpty.push({
            start: moment(allBlockRealiseOfBInjected[index - 1].end).format(DATE_TIME_FORMAT),
            end: moment(block.start).format(DATE_TIME_FORMAT)
          });
        }
      }
    });

    let i = 0;
    blockRealiseEmpty.forEach(block => {
      if (this.checkVacationInBlockRealiseEmpty(block, this.vacations, date)) {
        i++;
        return;
      }
    });


    return i == 0 && allBlockRealiseOfBInjected.length > 0;
  }

  private checkVacationInBlockRealiseEmpty(block: any, vacations: any[], date) {
    if (vacations.length == 2) {
      return this.checkIsVacationInRealise(vacations[0], block, date) && this.checkIsVacationInRealise(vacations[1], block, date);
    }

    return this.checkIsVacationInRealise(vacations[0], block, date);
  }


  checkIsVacationInRealise(vacation, block, date) {
    const formatVacation = (d, h) => moment(`${d} ${h}`);

    return (vacation.start1 && (formatVacation(date, vacation.start1).isBetween(moment(block.start), moment(block.end)))) ||
      (vacation.end1 && (formatVacation(date, vacation.end1).isBetween(moment(block.start), moment(block.end)))) ||
      (vacation.start2 && (formatVacation(date, vacation.start2).isBetween(moment(block.start), moment(block.end)))) ||
      (vacation.end2 && (formatVacation(date, vacation.end2).isBetween(moment(block.start), moment(block.end))));

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/modal/modal.component.ts